import { action } from '@ember/object';
import Component from '@glimmer/component';

export default class BackOfANapkinTemplatesNotesComponent extends Component {
  @action
  handleNotesChange(e) {
    const calculation = { ...this.args.calculation };
    calculation.notes = e;
    this.args.onValueEmit(calculation);
  }

  get modules() {
    const modules = {};

    let toolbarOptions = [
      ['bold', 'italic', 'strike'], // toggled buttons
      ['blockquote', 'code-block'],

      [{ header: 1 }, { header: 2 }], // custom button values
      [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
      ['link', 'clean'], // remove formatting button
    ];
    modules.toolbar = toolbarOptions;
    return modules;
  }
}
